const IBAN_LENGTHS: Record<string, number> = {
    AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, FI: 18,
    FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, HU: 28, IE: 22,
    IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LI: 21, LT: 20, LU: 20,
    LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30, NL: 18, NO: 15,
    PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, SA: 24, SE: 24, SI: 19,
    SK: 24, SM: 27, TN: 24, TR: 26, VG: 24,
};

export function normalizeIban(raw: string): string {
    return (raw || '').replace(/\s+/g, '').toUpperCase();
}

export function isValidIban(raw: string): boolean {
    const iban = normalizeIban(raw);
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) return false;
    const country = iban.slice(0, 2);
    const expected = IBAN_LENGTHS[country];
    if (!expected || iban.length !== expected) return false;

    const rearranged = iban.slice(4) + iban.slice(0, 4);
    let numeric = '';
    for (const c of rearranged) {
        numeric += /[A-Z]/.test(c) ? (c.charCodeAt(0) - 55).toString() : c;
    }
    let remainder = 0;
    for (const d of numeric) {
        remainder = (remainder * 10 + Number(d)) % 97;
    }
    return remainder === 1;
}

export function isValidBic(raw: string): boolean {
    const bic = (raw || '').replace(/\s+/g, '').toUpperCase();
    return /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic);
}
